import React, { FC } from 'react'
import styled, { css } from 'styled-components'
import {
  darkGrayColor,
  inactiveColor,
  primaryColor,
} from 'uiComponents/constants/colors'
import { fsXS, fwBold, fwMediumBold } from 'uiComponents/constants/typography'

const ButtonWrapper = styled.span`
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 12px;
  cursor: pointer;

  &:hover {
    > div {
      border: 2px solid ${primaryColor};
    }
    > label {
      color: ${primaryColor};
    }
  }
`

const StyledInput = styled.input`
  position: absolute;
  z-index: 10;
  opacity: 0;
  width: 20px;
  height: 20px;
  cursor: pointer;
`

const StyledRadioCheckbox = styled.div<{ selected: boolean }>`
  display: block;
  position: absolute;
  border: 2px solid ${inactiveColor};
  border-radius: 100%;
  height: 20px;
  width: 20px;
  top: 0px;
  left: 0px;
  transition: border 0.25s linear;

  &:before {
    display: block;
    position: absolute;
    content: '';
    border-radius: 100%;
    height: 8px;
    width: 8px;
    top: 4px;
    left: 4px;
    margin: auto;
    transition: background 0.25s linear;
  }

  ${({ selected }) =>
    selected &&
    css`
      border: 2px solid ${primaryColor};
      &:before {
        background: ${primaryColor};
      }
    `}
`

const StyledLabel = styled.label<{ selected: boolean }>`
  margin-left: 32px;
  font-size: ${fsXS}px;
  ${({ selected }) => (selected ? fwBold : fwMediumBold)};
  color: ${({ selected }) => (selected ? primaryColor : darkGrayColor)};
  cursor: pointer;
  transition: color 0.25s linear;
  pointer-events: none;
  text-transform: capitalize;
`

interface RadioButtonProps {
  identifier: string
  id: string
  label: string
  onClick: (id: string) => void
  selected: boolean
}
const RadioButton: FC<RadioButtonProps> = ({
  identifier,
  id,
  label,
  onClick,
  selected,
}) => {
  return (
    <ButtonWrapper
      onClick={() => onClick(id)}
      data-testid={'Radio_Button_Wrapper'}
    >
      <StyledInput
        id={id}
        type="radio"
        name={identifier}
        value={label}
        checked={selected}
        data-testid={`Radio_Button_${label}`}
      />
      <StyledLabel
        htmlFor={id}
        selected={selected}
        data-testid={'Radio_Button_Label'}
      >
        {label}
      </StyledLabel>
      <StyledRadioCheckbox selected={selected} />
    </ButtonWrapper>
  )
}

export default RadioButton
